<template>
    <div class="mb-4">
<!--        {{ $t('message.Orders') }}-->
        <ValidationObserver ref="observer">
            <div class="w-100 mt-2">
                <b-row>
                    <b-col md="10">
                        <label for="products">{{ $t('message.Product') }}</label>
                        <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Product')">
                            <v-select :options="products" label="name" v-model="form.product"></v-select>
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="2">
                        <label for="count">{{ $t('message.Count') }}</label>
                        <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Count')">
                            <input type="number" v-model="form.count" class="form-control">
                            <span class="text-danger">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
            </div>
            <div class="w-100 mt-2">
                <label for="products">{{ $t('message.Driver') }}</label>
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Driver')">
                    <v-select :options="drivers" label="full_name" v-model="form.driver"></v-select>
                    <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
            <div class="w-100 mt-2">
                <label for="products">{{ $t('message.Warehouse') }}</label>
                <ValidationProvider rules="required" v-slot="{ errors }" :name="$t('message.Warehouse')">
                    <v-select :options="warehous" v-model="form.warehous"></v-select>
                    <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
            </div>
        </ValidationObserver>
        <div class="w-100 mt-4 d-flex justify-content-end">
            <b-button variant="primary" @click="storeNewOrder" :disabled="db">{{ $t('message.Add') }}</b-button>
        </div>
    </div>
</template>

<script>
import {
    getInfoAll
} from "../../../../api/endpoints/products";
import vSelect from 'vue-select'
import {
    getUsers
} from "../../../../api/endpoints/users";
import {
    storeLeadOrder
} from "../../../../api/endpoints/orders";
import {
    getWarehouse
} from '../../../../api/endpoints/warehouse'

export default {
    name: "OrderForm",
    components: {
        vSelect,
    },
    props: {
        lead: {
            default: null,
        }
    },
    data() {
        return {
            products: [],
            drivers: [],
            form: {
                product: null,
                driver: null,
                count: 1,
                warehous: null,
            },
            warehous: [],
            db: false,
        }
    },
    created() {
        this.fetchProducts()
        this.fetchUsers()
        this.fetchWarehouse();
    },
    methods: {
        fetchProducts() {
            getInfoAll().then(res => {
                this.products = res.data.data;
                this.form.product = this.products[0]
            })
        },
        fetchUsers() {
            getUsers({
                driver: true
            }).then(res => {
                this.drivers = res.data.data;
                this.form.driver = this.drivers.filter(item => item.id === this.lead.client.driver_id)[0];
            })
        },
        async storeNewOrder() {
            this.db = true;
            setTimeout(() => {
                this.db = false;
            }, 700)
            const isValid = await this.$refs.observer.validate()
            if (isValid) {
                const form = {
                    product_id: this.form.product.id,
                    driver_id: this.form.driver.id,
                    quantity: this.form.count,
                    warehouse_id: this.form.warehous.value,
                    client_lead_id: this.lead.id ? this.lead.id : this.$route.params.id
                }
                storeLeadOrder(form).then(res => {
                    this.$emit('appendOrder', res.data.data);
                    this.$emit('reloadTable')
                })
            }
        },
        fetchWarehouse() {
            getWarehouse().then(res => {
                this.warehous = res.data.data.map(item => Object.assign({}, {
                    value: item.id,
                    label: item.name
                }))
                this.form.warehous = this.warehous[0]
            })
        },
    }
}
</script>

<style scoped>

</style>
